import { createRouter, createWebHashHistory } from "vue-router";

const routerItems = [
	{
		component: () => import("@/pages/Home/index.vue"),
		path: `/`,
		name: "首页",
		redirect: ""
	},
	{
		component: () => import("@/pages/Detail/index.vue"),
		path: `/productDetail`,
		name: "产品详情",
		redirect: ""
	}
];

console.log(window.deviceType);

const routers = createRouter({
	history: createWebHashHistory(),
	routes: routerItems
});

export default routers;
